import { AssistantCardProperties } from './types'
import Badge from '@/ui/components/Badge/Badge'
import AssistantIcon from '@/ui/components/AssistantIcon/AssistantIcon'

import './AssistantCard.scss'

const Card = ({ name, icon, iconSrc, description, tileHandler, badges, mode }: AssistantCardProperties) => {
    return (
        <div className="assistant-card-wrapper card-wrapper link" onClick={tileHandler}>
            <Badge badges={badges} mode={mode} position='top-left' />

            <div className='icon-wrapper'>
                <AssistantIcon icon={icon} iconSrc={iconSrc} alt={name} />
            </div>
            <div className='text-wrapper'>
                <p className="title">{name}</p>
                <p className="description">{description}</p>
            </div>
        </div>
    )
}

export default Card
